import consumer from "./consumer"

const MobileUploadChannel = {
  subscriptions: {},

  subscribe(uuid, callbacks) {
    if (this.subscriptions[uuid]) {
      this.unsubscribe(uuid)
    }

    const subscription = consumer.subscriptions.create({
      channel: "MobileUploadChannel",
      uuid: uuid
    }, {
      received(data) {
        if (data.event === 'files_uploaded' && callbacks.onFilesUploaded) {
          callbacks.onFilesUploaded(data)
        }
      }
    })

    this.subscriptions[uuid] = subscription
    return subscription
  },

  unsubscribe(uuid) {
    if (this.subscriptions[uuid]) {
      this.subscriptions[uuid].unsubscribe()
      delete this.subscriptions[uuid]
    }
  }
}

export default MobileUploadChannel
